import type { i18n as I18n } from 'i18next';
import { z } from 'zod';

/**
 * Generic validation messages in the current language. Schema-specific messages are
 * i18n keys like `validation.usernameFormat`, translated where they are displayed.
 */
export function configureZodErrors(i18n: I18n): void {
  const t = (key: string, options?: Record<string, unknown>) =>
    i18n.t(`validation:${key}`, options);

  z.config({
    customError: (issue) => {
      switch (issue.code) {
        case 'too_small':
          if (issue.origin === 'string') {
            return Number(issue.minimum) <= 1
              ? t('required')
              : t('minLength', { count: Number(issue.minimum) });
          }
          if (issue.origin === 'array') return t('required');
          return t('min', { min: issue.minimum });
        case 'too_big':
          if (issue.origin === 'string') return t('maxLength', { count: Number(issue.maximum) });
          return t('max', { max: issue.maximum });
        case 'invalid_format':
          if (issue.format === 'email') return t('email');
          if (issue.format === 'url') return t('url');
          return t('format');
        case 'invalid_type':
          return issue.input === undefined || issue.input === null || Number.isNaN(issue.input)
            ? t('required')
            : t('invalid');
        case 'invalid_value':
          return t('invalid');
        default:
          return undefined;
      }
    },
  });
}
